export interface StatusMenuSubmenu {
  id: string;
  label: string;
  order: number;
  codes: string[];
}

export interface StatusMenu {
  id: string;
  order: number;
  label: string;
  submenus: StatusMenuSubmenu[];
}

export interface RailStatusEntry {
  code: string;
  menu?: string | null;
  submenu?: string | null;
}

const STATUS_MENU_CONFIG = [
  {
    id: "onboarding",
    label: "Onboarding",
    order: 1,
    submenus: [
      { id: "cotizacion", label: "Cotización", order: 1 },
      { id: "cuenta", label: "Cuenta", order: 2 },
      { id: "empresa", label: "Empresa", order: 3 },
      { id: "accionista", label: "Accionista", order: 4 },
      { id: "decision", label: "Decisión", order: 5 },
      { id: "ingresos", label: "Ingresos", order: 6 },
      { id: "resultados", label: "Resultados", order: 7 },
    ],
  },
  {
    id: "expediente",
    label: "Expediente",
    order: 2,
    submenus: [
      { id: "datos", label: "Datos", order: 1 },
      { id: "documentos", label: "Documentos", order: 2 },
      { id: "validacion", label: "Validación", order: 3 },
    ],
  },
  {
    id: "firma",
    label: "Firma",
    order: 3,
    submenus: [
      { id: "resultado", label: "Resultado", order: 1 },
      { id: "contratos", label: "Contratos", order: 2 },
      { id: "firma", label: "Firma", order: 3 },
    ],
  },
];

export const buildRailFromStatusConfig = (statusConfig: RailStatusEntry[]): StatusMenu[] => {
  const result = STATUS_MENU_CONFIG.map((menu) => ({
    id: menu.id,
    order: menu.order,
    label: menu.label,
    submenus: menu.submenus.flatMap((sub): StatusMenuSubmenu[] => {
      const codes = [
        ...new Set(statusConfig.filter((e) => e.menu === menu.id && e.submenu === sub.id).map((e) => e.code)),
      ];
      return codes.length ? [{ id: sub.id, label: sub.label, order: sub.order, codes }] : [];
    }),
  }));

  return result;
};

export const resolveRailPosition = (
  groups: StatusMenu[],
  statusCode: string,
): { groupIndex: number; phaseIndex: number } => {
  if (!statusCode) return { groupIndex: -1, phaseIndex: -1 };

  for (let groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
    const phaseIndex = groups[groupIndex].submenus.findIndex((sub) => sub.codes.includes(statusCode));
    if (phaseIndex !== -1) return { groupIndex, phaseIndex };
  }

  return { groupIndex: -1, phaseIndex: -1 };
};
